export const version = "2.1.3"
export const reCapKey = "6Ld_Cu0gAAAAAIhC4cGfa3ZZ91surXuBtkBR16zg";

const trimTrailingSlash = (value) => value.replace(/\/+$/, '');

export const API_URL = trimTrailingSlash(
  process.env.REACT_APP_API_URL || "https://pos-server.wellclean.com.my/staging/"
);

export const CHECK_BILL_URL = /\/(checkBillStatus|check-status)$/i.test(API_URL)
  ? API_URL
  : API_URL.endsWith('/service-bill')
    ? `${API_URL}/check-status`
    : `${API_URL}/checkBillStatus`;
